<template>
  <UiContainer class="relative">
    <template v-if="!loading && value">
      <UiTitle severity="h2" class="mb-3">На карте</UiTitle>

      <div
        v-if="value.address"
        class="!absolute bottom-2 left-7 z-10 w-[calc(100%_-_56px)] md:left-9 md:w-fit"
      >
        <UiButton
          severity="tertiary"
          class="flex w-full items-center justify-between px-5 py-3 text-left text-sm"
          @click="copyAddress"
        >
          {{ value.address.normalized }}
          <UiIcon
            name="square-2-stack"
            class="ml-3 size-5 min-w-5 self-center text-icon-tertiary"
          />
        </UiButton>
      </div>
      <VenueYandexMap
        :value="[value]"
        :active-venue="value"
        :height="isLgAndDown ? '56vh' : '496px'"
        disable-markers
        :static="isMdAndDown"
      />
    </template>
    <template v-else>
      <VenueAddressInfoSkeleton />
    </template>
  </UiContainer>
</template>

<script setup lang="ts">
import copyToClipboard from 'copy-to-clipboard'
import { toast } from 'vue3-toastify'
import { type Venue, VenueYandexMap } from '@/5_entities/Venue'
import { useBreakpoint } from '@/6_shared/lib'
import { UiButton, UiContainer, UiIcon, UiTitle } from '@/6_shared/ui'
import VenueAddressInfoSkeleton from './VenueAddressInfoSkeleton.vue'

type PropType = {
  value?: Venue
  loading?: boolean
}

const props = withDefaults(defineProps<PropType>(), {
  value: undefined,
  loading: false
})
const {
  md: [_isMdAndUp, isMdAndDown],
  lg: [_isLgAndUp, isLgAndDown]
} = useBreakpoint()

const copyAddress = () => {
  if (!props.value?.address) return

  copyToClipboard(props.value.address.normalized)
  toast.success('Адрес скопирован')
}
</script>
